import React from 'react';
import { Group, Rect, Text } from 'react-konva';

import { getTextWidth } from '../lib';
import TableSize = GM.ReservesSchemas.TableSize;

const CanvasTableNumber = ({
  number,
  container,
  tableSize,
  hasNextReserve,
  colors,
  // isMobile = false,
}: {
  number: string;
  container: { width: number; height: number; offsetY?: number };
  tableSize: TableSize;
  hasNextReserve?: boolean;
  colors: GM.ReservesSchemas.TableStateColorSet;
  // isMobile?: boolean;
}) => {
  let baseTextSize: number;
  let dotBaseSize: number;
  if (tableSize === 'S') {
    // baseTextSize = isMobile ? 16 : 12;
    baseTextSize = 12;
    dotBaseSize = 4;
  } else if (tableSize === 'M') {
    // baseTextSize = isMobile ? 20 : 16;
    baseTextSize = 16;
    dotBaseSize = 6;
  } else if (tableSize === 'L') {
    // baseTextSize = isMobile ? 24 : 20;
    baseTextSize = 20;
    dotBaseSize = 6;
  }

  if (!hasNextReserve) {
    dotBaseSize = 0;
  }

  const offsetY = container.offsetY ?? 0;

  const {
    fontSize,
    width: numberWidth,
    height: numberHeight,
  } = getCanvasTableNumberLayout(number, baseTextSize);

  const dotBaseGap = 0;
  const dotSize = dotBaseSize;
  const dotGap = dotBaseGap;
  const dotOffsetY = -dotSize * 0.5;
  const contentTop = Math.min(0, dotOffsetY);
  const contentBottom = Math.max(numberHeight, dotOffsetY + dotSize);
  const contentHeight = contentBottom - contentTop;
  const contentWidth = numberWidth + dotGap + dotSize;

  const groupX = (container.width - contentWidth) / 2;
  const groupY = (container.height - offsetY - contentHeight) / 2 - contentTop;

  return (
    <Group x={groupX} y={offsetY + groupY}>
      <Text
        text={number}
        fontSize={fontSize}
        fontFamily="Geologica"
        // TODO Не срабатывает fontWeight, пока отложил
        // fontWeight="600"
        fill={colors.number.color}
      />
      {hasNextReserve && (
        <Rect
          x={numberWidth + dotGap}
          y={dotOffsetY}
          width={dotSize}
          height={dotSize}
          cornerRadius={dotSize / 2}
          fill={colors.number.dot}
        />
      )}
    </Group>
  );
};

const getCanvasTableNumberLayout = (number: string, baseTextSize: number) => {
  const fontSize = baseTextSize;
  const width = getTextWidth(number, fontSize);
  const height = fontSize;

  return {
    fontSize,
    width,
    height,
  };
};

export default CanvasTableNumber;
